import { Link, useLocation } from 'react-router-dom';

const MODES = [
  { to: '/', label: 'ImNotGoing', sub: 'Excuses' },
  { to: '/havingit', label: 'ImNotHavingIt', sub: 'Replies' },
];

export default function ModeToggle() {
  const { pathname } = useLocation();
  const activePath = pathname === '/havingit' ? '/havingit' : '/';

  return (
    <div
      role="tablist"
      aria-label="Mode"
      style={{
        display: 'inline-flex',
        padding: 4,
        background: 'var(--card-bg)',
        border: '1px solid var(--border)',
        borderRadius: 999,
        gap: 4,
        marginBottom: 28,
      }}
    >
      {MODES.map((mode) => {
        const active = mode.to === activePath;
        return (
          <Link
            key={mode.to}
            to={mode.to}
            role="tab"
            aria-selected={active}
            style={{
              padding: '8px 18px',
              borderRadius: 999,
              fontSize: 13,
              fontWeight: active ? 600 : 400,
              letterSpacing: '-0.005em',
              color: active ? '#0f0f0f' : 'var(--fg-muted)',
              background: active ? 'var(--accent)' : 'transparent',
              textDecoration: 'none',
              transition: 'all 0.15s',
              display: 'inline-flex',
              alignItems: 'baseline',
              gap: 8,
            }}
          >
            <span>{mode.label}</span>
            <span
              style={{
                fontSize: 10,
                fontWeight: 500,
                letterSpacing: '0.08em',
                textTransform: 'uppercase',
                opacity: active ? 0.55 : 0.7,
              }}
            >
              {mode.sub}
            </span>
          </Link>
        );
      })}
    </div>
  );
}
